import { Text } from "@mdotm/shadcn/legacy/components";
import { overrideClassName, toClassName } from "@mdotm/shadcn/legacy/react-extensions";
import type { CSSProperties, JSX, ReactNode } from "react";

function GraphLegend({
	children,
	style,
	className,
}: {
	children: ReactNode;
	style?: CSSProperties;
	className?: string;
}): JSX.Element {
	return (
		<div
			style={style}
			className={overrideClassName(
				toClassName({
					"mt-3 flex items-end flex-wrap": true,
					"[&>.legend-container]:flex [&>.legend-container]:items-center [&>.legend-container]:mr-1.5 [&>.legend-container>svg]:mr-1.5": true,
					"[&>.condensed]:h-[20px] [&>.condensed]:mr-[18px] [&>.condensed>svg]:mr-[5px] [&>.legend-container>.condensed>svg:last-of-type]:mr-[5px]": true,
					"[&>.light]:text-[#8c8ea8] [&>.more-space]:mr-[20px] [&>.book]:text-[10px]": true,
				}),
				className,
			)}
		>
			{children}
		</div>
	);
}

export function GraphLegendTextKey({ children }: { children: ReactNode }): JSX.Element {
	return (
		<Text className="mr-1" type="Body/S/Light-UPPERCASE">
			{children}
		</Text>
	);
}

export function GraphLegendLabel({ children }: { children: ReactNode }): JSX.Element {
	return (
		<Text type="Body/S/Book" color="#8c8ea8">
			{children}
		</Text>
	);
}

export default GraphLegend;
